import React, { useContext, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';

import { ButtonNoStyles } from '@styled';

import colors from '@general/colors';
import fonts from '@general/fonts';
import { ConversationsContext } from '../../../context/ConversationsProvider';
import { ConversationsClientContext } from '../../../context/ConversationsClientProvider';
import useConversationMessages from './hooks/useConversationMessages';
import { ChatUserContext } from '../../../context/ChatUserProvider';

const InputContainerStyled = styled.div`
    display: flex;
    flex-direction: row;
`;

const SubmitButtonStyled = styled.button`
    background-color: ${props => (props.isDisabled ? colors.lightGray : colors.azure)};
    border: none;
    padding: 0 3rem;
    color: ${colors.white};
    font-family: ${fonts.sans};
`;

const InputStyled = styled.input`
    width: 100%;
    border: 1px solid ${colors.lightGray};
    outline: none;
    font-family: ${fonts.sans};
    ::placeholder {
        color: ${colors.background};
    }
`;

const MessageInput = () => {
    const { doesChatUserExist } = useContext(ChatUserContext);
    const searchInputRef = useRef(null);
    const [isSending, setIsSending] = useState(false);
    const [isDisabled, setIsDisabled] = useState(true);
    const { conversations, currentConversation, sendMessageToConversation } = useContext(ConversationsContext);
    const { firstPageMessageData } = useConversationMessages(currentConversation);
    const { statusString, status } = useContext(ConversationsClientContext);
    const [newMessage, setNewMessage] = useState('');
    const [focused, setFocused] = useState(false);

    const onBlur = () => setFocused(false);
    const onFocus = () => setFocused(true);
    // if input is focused, update last read

    useEffect(() => {
        (async () => {
            if (!focused || !currentConversation) return;
            await currentConversation.updateLastReadMessageIndex(currentConversation.channelState.lastMessage?.index);
        })();
    }, [currentConversation, focused]);

    useEffect(() => {
        (async () => {
            if (document.activeElement === searchInputRef.current && currentConversation) {
                await currentConversation.updateLastReadMessageIndex(
                    currentConversation.channelState.lastMessage?.index
                );
            }
        })();
    }, [currentConversation, firstPageMessageData]);

    useEffect(() => {
        if (!conversations || conversations.length === 0 || status !== 'success' || doesChatUserExist === false) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
    }, [conversations, doesChatUserExist, status]);

    const sendMessage = async event => {
        event.preventDefault();
        if (isSending || !newMessage) return;
        setIsSending(true);
        await sendMessageToConversation({ conversation: currentConversation, messageText: newMessage });
        setNewMessage('');
        setIsSending(false);
    };

    const handleDeleteAll = async () => {
        for (const convo of conversations) {
            await convo.leave();
            await convo.delete();
        }
    };

    return (
        <form className="fade-in-fast" onSubmit={sendMessage}>
            <InputContainerStyled>
                <InputStyled
                    ref={searchInputRef}
                    type="text"
                    placeholder="Write a message..."
                    autoComplete="off"
                    autoCorrect="off"
                    autoCapitalize="off"
                    spellCheck="false"
                    className="p-3"
                    disabled={isDisabled}
                    onChange={event => setNewMessage(event.target.value)}
                    value={newMessage}
                    onBlur={onBlur}
                    onFocus={onFocus}
                />
                <SubmitButtonStyled type="submit" title="Send message" isDisabled={isDisabled}>
                    Submit
                </SubmitButtonStyled>
            </InputContainerStyled>
            {/* <p
                style={{
                    marginTop: '16px',
                    lineHeight: '1.2rem',
                    fontSize: '0.9rem',
                    marginBottom: 0,
                    color: '#5F5F5F',
                }}
            >
                {statusString}
            </p>
            <ButtonNoStyles type="button" onClick={handleDeleteAll}>
                Delete All Conversations
            </ButtonNoStyles> */}
        </form>
    );
};

// MessageInput.propTypes = {
//     prop: PropTypes.
// };

export default MessageInput;
